/**
 * CreateStore queries
 */
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const createStoreMutation = graphql(
  gql`
    mutation createTeamStore($teamStore: TeamStoreInput!) {
      store: createTeamStore(teamStore: $teamStore) {
        shortId: short_id
      }
    }
  `,
  { name: 'createStore' }
)

export const updateStoreMutation = graphql(
  gql`
    mutation updateTeamStore($teamStore: TeamStoreInput!, $file: Upload) {
      store: updateTeamStore(teamStore: $teamStore, file: $file) {
        message
      }
    }
  `,
  { name: 'updateStore' }
)

export const GetTeamStoreQuery = gql`
  query GetTeamStore($teamStoreId: String!) {
    teamStore: getTeamStore(teamStoreId: $teamStoreId) {
      id
      shortId: short_id
      name
      banner
      bannerDarkMode: banner_dark_mode
      bulletin
      startDate: cutOffDateString
      endDate: deliveryDateString
      privateStore: private
      passCode: passcode_raw
      passCodeHashed: passcode
      created_at
      bulkShipOption: bulk_ship_option
      isMandatory: is_mandatory
      bulkShipPrivate: bulk_ship_private
      bulkShipFirstName: bulk_ship_first_name
      bulkShipLastName: bulk_ship_last_name
      bulkShipStreet: bulk_ship_street
      bulkShipApartment: bulk_ship_apartment
      bulkShipCountry: bulk_ship_country
      bulkShipStateProvince: bulk_ship_state_province
      bulkShipStateProvinceCode: bulk_ship_state_province_code
      bulkShipCity: bulk_ship_city
      bulkShipZipCode: bulk_ship_zip_code
      bulkShipPhone: bulk_ship_phone
      fixedPrice: fixed_price
      items {
        id
        visible
        isInline: is_inline
        design_id
        totalOrders
        resellerRange {
          price
          shortName: short_name
          quantity
          abbreviation
        }
        priceRange {
          price
          shortName: short_name
          quantity
          abbreviation
        }
        design {
          id
          code
          image
          name
          proDesign: pro_design
          proCertified: pro_certified
          qualityWarning: quality_warning
          isDraft: is_draft
          shortId: short_id
          product {
            id
            type: name
            description
            shortDescription: short_description
            yotpoId: yotpo_id
            priceRange {
              quantity
              price
              abbreviation
              shortName: short_name
            }
            pictures: original_pictures {
              front: front_image
              thumbnail
            }
          }
        }
      }
      onDemand: on_demand_mode
      teamSize {
        id
        size
      }
      owner
      datesEdited: dates_edited
    }
  }
`

export const cutoffDateSettingsQuery = gql`
  query getCutoffConfig {
    data: getCutoffConfigData {
      cutoff_settings
      cutoff_settings_ca
    }
  }
`

export const profileSettingsQuery = gql`
  query profile {
    profileData: getUserProfile {
      userProfile {
        id
        country_code
      }
      reseller {
        id
        status
        margin
        comission
        currency
        paypalAccount: paypal_account
        displayDynamicBatch: display_dynamic_batch
        displayFixedBatch: display_fixed_batch
        marginBatch: margin_batch
        marginBatch2: margin_batch_2
        marginBatch3: margin_batch_3
        marginBatch4: margin_batch_4
        marginBatch5: margin_batch_5
        marginBatch6: margin_batch_6
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/CreateStore/data.ts